import {
  JumpType,
  LoginType,
  GoodsType,
  PMLinkType,
  POINTS_MALL_URL_LIST,
  ActivityType,
  QY_WECHAT_JOIN_PATH_CONFIG,
  COMMUNITY_JOIN_PATH_CONFIG,
  MEMBER_PAGE_PATH_CONFIG,
  USER_LIMIT_STATUS
} from "../../../../commons/commonVariables";
import wx from "weixin-js-sdk";
import {
  BigWheelConstants as BWC,
  CoordinateType,
  EnvMark
} from "../lucky-draw/common/global-variable";
import comUtils, {
  loadAlipayWebViewScript
} from "../../../../utils/comUtils.js";
import { Toast, Dialog } from "vant";
import axios from "../../../../api/axios.js";
import { AMapGetLocation } from "../TMap.js";

/**
 * 跳转下级活动
 * @param {string} link 跳转链接
 * @param {string} type 跳转类型
 * @param {string} loginType 登录类型
 * @param {object} _this （非必传）执行该方法的上下文,自定义链接跳转需要
 * @param {object} params （非必传）跳转链接的传参，目前包含字段，(1)memberCenterId：会员id，跳转积分页需要，
 * (2)urlAppendStr：跳转自定义链接场景，拼接参数到URL末尾,(3)activityCode：活动code，跳转积分商城需要
 * @returns
 */
export function jumpToNext(link, type, loginType, _this = this, params = {}) {
  // 没有登录类型
  if (loginType !== LoginType.Wechat && loginType !== LoginType.Alipay) {
    console.error("登录类型未知");
    return;
  }
  //   不跳转类型
  if (type === JumpType.noJump) {
    return;
  }

  // type=1，跳转到小程序首页
  if (type === JumpType.homePage) {
    // 微信
    if (loginType === LoginType.Wechat) {
      wx.miniProgram.switchTab({
        url: "/pages/tabBar/index/index"
      });
    } else {
      // 支付宝
      my.switchTab({
        url: "/pages/tabBar/index/index"
      });
    }
  }
  //type=2，自定义链接
  if (link && type === JumpType.customLink) {
    const urlAppendStr = params.urlAppendStr ? params.urlAppendStr : "";
    // 跳转积分商城
    if (pointsMallLinkJudge(link) !== PMLinkType.notMatch) {
      jumpToPointsMall(params.activityCode, link);
      return;
    }
    // 2-1.跳转链接包含网址，且没有字段webViewSrc
    if (
      (link.includes("http") || link.includes("https")) &&
      !link.includes("webViewSrc")
    ) {
      // 2-1-1.活力魔方
      if (link.includes("hdmain")) {
        const path = "/hdmain?" + link.split("?")[1];

        _this.$router.push({
          path: path + urlAppendStr
        });
      } else {
        // 2-1-2.其他网址
        window.location.href = link + urlAppendStr;
      }
    } else if (
      !link.includes("http") &&
      !link.includes("https") &&
      link.includes("HD")
    ) {
      // 2-2.跳转链接为一个活动编码，例:HD1687663056563
      const path = "/hdmain?activityCode=" + link;
      _this.$router.push({
        path: path + urlAppendStr
      });
    } else {
      // 2-3.小程序链接 (小程序页面、活动)
      let usePath = link;
      if (link.includes("webViewSrc")) {
        const h5Url = link.split('webViewSrc=')[1] || '';
        const goUrl = h5Url ? encodeURIComponent(h5Url) : '';
        usePath = `/pages/webView/activity-web-view?webViewSrc=${goUrl}`;
      }
      if (loginType === LoginType.Wechat) {
        //在微信小程序内部打开
        link.startsWith("/pages/tabBar") &&
          wx.miniProgram.switchTab({
            url: link
          });
        !link.startsWith("/pages/tabBar") &&
          wx.miniProgram.navigateTo({
            url: usePath
          });
      } else {
        // 在支付宝小程序内部打开
        link.startsWith("/pages/tabBar") &&
          my.switchTab({
            url: link
          });
        !link.startsWith("/pages/tabBar") &&
          my.navigateTo({
            url: usePath
          });
      }
    }
  }
  // type=4，优惠券
  if (type === JumpType.couponPage) {
    if (loginType === LoginType.Wechat) {
      wx.miniProgram.navigateTo({
        url: `/subpackages/my/pages/couponList/coupon-list?couponType=0`
      });
    } else {
      my.navigateTo({
        url: `/subpackages/my/pages/couponList/coupon-list?couponType=0`
      });
    }
  }
  // type=0,代金券
  if (type === JumpType.voucherPage) {
    if (loginType === LoginType.Wechat) {
      wx.miniProgram.navigateTo({
        url: `/subpackages/my/pages/couponList/coupon-list?couponType=1`
      });
    } else {
      my.navigateTo({
        url: `/subpackages/my/pages/couponList/coupon-list?couponType=1`
      });
    }
  }
  // type=11,免息券
  if (type === JumpType.interestFreePage) {
    if (loginType === LoginType.Wechat) {
      wx.miniProgram.navigateTo({
        url: `/subpackages/my/pages/couponList/coupon-list?couponType=2`
      });
    } else {
      my.navigateTo({
        url: `/subpackages/my/pages/couponList/coupon-list?couponType=2`
      });
    }
  }
  // type=5,积分
  if (type === JumpType.pointsPage) {
    if (loginType === LoginType.Wechat) {
      wx.miniProgram.navigateTo({
        url: `/subpackages/my/pages/growthValue/growth-value?memberCenterId=${params.memberCenterId}&title=积分`
      });
    } else {
      my.navigateTo({
        url: `/subpackages/my/pages/growthValue/growth-value?memberCenterId=${params.memberCenterId}&title=积分`
      });
    }
  }
  // type=6,奖励查询
  if (type === JumpType.rewardInquiry) {
    if (loginType === LoginType.Wechat) {
      wx.miniProgram.navigateTo({
        url: `/subpackages/my/pages/rewardQuery/reward-query`
      });
    } else {
      my.navigateTo({
        url: `/subpackages/my/pages/rewardQuery/reward-query`
      });
    }
  }
  // type=10,小程序我的
  if (type === JumpType.my) {
    if (loginType === LoginType.Wechat) {
      wx.miniProgram.switchTab({
        url: `/pages/tabBar/my/my`
      });
    } else {
      my.switchTab({
        url: `/pages/tabBar/my/my`
      });
    }
  }
}

/**
 * 跳转到Hi荣耀首页，包括支付宝H5，支付宝小程序内H5，微信小程序内H5
 * @param {String} loginType 登录类型，微信或支付宝
 * @param {String} activityUrl 活动链接，用于跳转回当前活动
 * @returns
 */
export function goHiHonorIndex(loginType, activityUrl) {
  try {
    const envMark = getEnvMark();
    const isInMP = envMark === EnvMark.wechatMp || envMark === EnvMark.alipayMp;
    if (loginType === BWC.LoginType.Wechat) {
      // 微信小程序内
      if (isInMP) {
        wx.miniProgram.postMessage({
          h5LoginToMiniFlag: true
        });
        wx.miniProgram.reLaunch({
          url:
            "/pages/tabBar/index/index?activityUrl=" +
            encodeURIComponent(activityUrl)
        });
      } else {
        // 微信H5，暂不支持
      }
    } else if (loginType === BWC.LoginType.Alipay) {
      // 支付宝小程序内
      if (isInMP) {
        loadAlipayWebViewScript().then(res => {
          console.log("支付宝环境下", res);
          if (res) {
            //判断是否运行在支付宝小程序环境里
            my.postMessage({
              activityUrl: encodeURIComponent(activityUrl)
            });
            my.reLaunch({
              url:
                "/pages/tabBar/index/index?activityUrl=" +
                encodeURIComponent(activityUrl)
            });
          }
        });
      } else {
        // 支付宝H5
        const query = "activityUrl=" + encodeURIComponent(activityUrl);
        window.location.href =
          "alipays://platformapi/startapp?appId=2021002121684220&page=pages/tabBar/index/index&query=" +
          query;
      }
    }
  } catch (err) {
    console.error(err);
  }
}

/**
 * 未登录处理，跳转到小程序首页进行登录
 * @param {String} loginType 登录类型，微信或支付宝
 * @param {String} activityUrl 当前活动链接
 * @returns
 */
export function noLoginHandler(loginType, activityUrl) {
  goHiHonorIndex(loginType, activityUrl);
}

/**
 * 获取当前H5所处的环境标识
 * @returns
 */
export function getEnvMark() {
  const ua = window.navigator.userAgent.toLowerCase();
  let mark = EnvMark.otherBrowser;
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    // 大部分手机可采用此判断，是否是小程序，但有小部分华为等手机因为加载慢，这里会出现误判
    if (
      window.__wxjs_environment === "miniprogram" ||
      ua.match(/miniprogram/i) == "miniprogram"
    ) {
      // 微信小程序
      mark = EnvMark.wechatMp;
    } else {
      // 微信H5
      mark = EnvMark.wechatH5;
    }
  } else if (/AlipayClient/.test(window.navigator.userAgent)) {
    // 此处用ua和miniprogram判断，先查看兼容性，使用my.getEnv为异步，不适合此处
    if (
      ua.match(/miniprogram/i) == "miniprogram" ||
      ua.match(/webview/i) == "webview"
    ) {
      // 支付宝小程序
      mark = EnvMark.alipayMp;
    } else {
      // 支付宝H5
      mark = EnvMark.alipayH5;
    }
  }
  sessionStorage.setItem("envMark", mark);
  return mark;
}

/**
 * 是否为完整的积分商城链接
 * @param {String} url
 * @returns
 */
function isFullPMLink(url) {
  if (url && url.startsWith("http")) {
    try {
      // 解析URL
      const parsedUrl = new URL(url);
      const path = `${parsedUrl.host}${parsedUrl.pathname}`;

      // 兼容测试环境和生产
      const res = POINTS_MALL_URL_LIST.includes(path);
      return res;
    } catch (err) {
      console.error("isFullPMLink===>error:", err);
      return false;
    }
  } else {
    return false;
  }
}

/**
 *  判断是否为积分商城的链接，并返回对应类型
 * @param {String} url
 */
export function pointsMallLinkJudge(url) {
  if (url && url.trim() === BWC.jumpToPage.pointsMall) {
    return PMLinkType.shortLink;
  } else if (url && isFullPMLink(url)) {
    return PMLinkType.fullLink;
  } else {
    return PMLinkType.notMatch;
  }
}

/**
 * 跳转积分商城，只能在小程序内使用
 * @param {String} activityCode 活动编码
 * @param {String} url 跳转链接（非必传）
 */
export function jumpToPointsMall(activityCode, url = "") {
  const env = getEnvMark();
  console.log("jumpToPointsMall=========>env", env);
  console.log("jumpToPointsMall=========>url", url);
  let urlParams = `pointsMallFromIHLP&activityCode=${activityCode}`;
  if (pointsMallLinkJudge(url) === PMLinkType.fullLink) {
    // 长链接跳转
    urlParams += `&link=${url}`;
  }
  const jumpUrl = `/pages/webView/activity-web-view?webViewSrc=${encodeURIComponent(
    urlParams
  )}`;
  if (env === EnvMark.wechatMp) {
    wx.miniProgram.navigateTo({
      url: jumpUrl,
      fail: function (res) {
        console.error("跳转回小程序的页面fail", res);
      }
    });
  } else if (env === EnvMark.alipayMp) {
    loadAlipayWebViewScript().then(res => {
      if (res) {
        my.navigateTo({
          url: jumpUrl,
          fail: function (res) {
            console.log("跳转回小程序的页面fail", res);
          }
        });
      }
    });
  }
}

/**
 * 获取wx.config方法的签名URL
 * @returns
 */
export function getSignUrl() {
  let signLink = "";
  const ua = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) {
    signLink = sessionStorage.getItem("WxCodeUrl");
    if (!signLink) signLink = location.href;
  } else {
    signLink = location.href;
  }
  return signLink;
}

/**
 * 门店跳转地图导航页
 * @param {*} storeInfo 门店信息
 * @param {*} loginType 登录类型
 */
export function jumpToMapNavigation(storeInfo, loginType) {
  const env = getEnvMark();
  const phone = storeInfo.sensitizationMobilephone || storeInfo.telephone;
  //如果在小程序环境则调用小程序的方法跳转
  if (env === EnvMark.alipayMp || env === EnvMark.wechatMp) {
    const params = `latitude=${storeInfo.gcj02Latitude}&longitude=${storeInfo.gcj02Longitude}&channelName=${storeInfo.channelName}&channelAddress=${storeInfo.channelAddress}`;
    console.log("跳转地图导航页方法", storeInfo, params);
    if (loginType === LoginType.Wechat) {
      wx.miniProgram.navigateTo({
        url: `/subpackages/activity/pages/activityOpenLocation/activity-open-location?${params}`
      });
    } else if (loginType === LoginType.Alipay) {
      my.navigateTo({
        url: `/subpackages/activity/pages/activityOpenLocation/activity-open-location?${params}`
      });
    }
  } else {
    // 默认使用高德地图
    const url = `https://uri.amap.com/marker?position=${storeInfo.gcj02Longitude},${storeInfo.gcj02Latitude}&name=${storeInfo.channelName}&src=hd&coordinate=gaode&callnative=0`;
    window.location.href = url;
  }
}

/**
 * 跳转小程序首页，获取位置信息。只在小程序内可用
 * @param {String} loginType 登录类型
 * @param {String} activityUrl 活动链接
 */
export function obtainLocationInfo(loginType, activityUrl) {
  try {
    const envMark = getEnvMark();
    // 拼接跳转链接
    const jumpUrl = encodeURIComponent(activityUrl + "&obtainLocation=true");
    if (loginType === BWC.LoginType.Wechat && envMark === EnvMark.wechatMp) {
      // 微信小程序内
      wx.miniProgram.reLaunch({
        url: "/pages/tabBar/index/index?activityUrl=" + jumpUrl
      });
    } else if (
      loginType === BWC.LoginType.Alipay &&
      envMark === EnvMark.alipayMp
    ) {
      // 支付宝小程序内
      loadAlipayWebViewScript().then(res => {
        if (res) {
          //判断是否运行在支付宝小程序环境里
          my.reLaunch({
            url: "/pages/tabBar/index/index?activityUrl=" + jumpUrl
          });
        }
      });
    }
  } catch (err) {
    console.error(err);
  }
}

/**
 * 校验权益品是否在有效期内
 */
export function getValidity(params, rewardType) {
  // 奖品Id不为空，且中奖类型排除积分
  if (params.goodsId && rewardType !== GoodsType.accumulatePoints) {
    // goodsId: 权益品id,
    // rewardRecodeId: 中奖记录表id
    // activityCode: 活动编码
    return new Promise(resolve => {
      axios.post({
        noLoading: true,
        sc: "mobileMarketing",
        url: `h5/bigWheel/getWriteOff`,
        params: params,
        success: r => {
          if (r.code === 200) {
            resolve(true);
          } else {
            // 提示核销码不在有效期
            Toast(r.message);
            resolve(false);
          }
        }
      });
    });
  } else {
    // 奖品ID为空，或奖品为积分，不进行有效期校验
    // 返回结果为true，认为在有效期内
    return true;
  }
}

/**
 * 校验是否是全部登录类型（支付宝+微信）
 * @param {*} loginType
 */
export function isAllLogin(loginType) {
  const arr = loginType.split(",");
  if (
    arr.length === 2 &&
    arr.includes(LoginType.Alipay) &&
    arr.includes(LoginType.Wechat)
  ) {
    return true;
  } else {
    return false;
  }
}

/**
 * 校验活动打开的客户端是否正确
 * @param {String} loginType 登录类型
 */
export function checkClient(loginType) {
  // 本地调试放开校验
  const hostname = window.location.hostname;
  if (hostname === "localhost") {
    return true;
  }
  // 获取环境标识，与登录类型做联合判断
  const envMark = getEnvMark();
  if (loginType === LoginType.Wechat) {
    return envMark === EnvMark.wechatH5 || envMark === EnvMark.wechatMp;
  } else if (loginType === LoginType.Alipay) {
    return envMark === EnvMark.alipayH5 || envMark === EnvMark.alipayMp;
  } else if (isAllLogin(loginType)) {
    // 全部登录类型，只能在微信或支付宝场景打开
    return envMark !== EnvMark.otherBrowser;
  } else {
    // 无需登录场景，任何客户端均可打开
    return true;
  }
}

/**
 * 获取开放标签、SDK API的授权
 * @param {Array} tagList 开放标签列表，默认为：["wx-open-launch-weapp"]
 * @param {Array} apiList api名称列表，默认为：[""]
 */
export function getWxSDKAuth(
  tagList = ["wx-open-launch-weapp"],
  apiList = [""]
) {
  return new Promise(resolve => {
    const env = getEnvMark();
    if (env === EnvMark.wechatH5 || env === EnvMark.wechatMp) {
      console.log("getWxSDKAuth=====>url: ", getSignUrl());
      axios.post({
        noLoading: true,
        sc: "mobileMarketingH5",
        url: `getShareParams?url=${encodeURIComponent(getSignUrl())}`,
        success: r => {
          const result = r.result || {};
          const appId = result.appId;
          const timestamp = result.timestamp;
          const nonceStr = result.nonceStr;
          const signature = result.signature;
          wx.config({
            debug: false,
            appId: appId,
            timestamp: timestamp,
            nonceStr: nonceStr,
            signature: signature,
            jsApiList: apiList,
            openTagList: tagList // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
          });
          resolve(true);
        },
        fail: err => {
          console.error("getWxSDKAuth===>error", err);
          resolve(false);
        }
      });
    } else {
      resolve(false);
    }
  });
}

/**
 * 专题活动，权益品、代金券楼层数据处理
 * @param {*} result
 * @param {*} item
 * @returns
 */
export function getGoodsList(result, item) {
  // 根据pageType不同，映射不同的字段 voucher取couponMainVOList  exchangegoods取exchangeGoodsVOList
  const fieldMap = {
    voucher: "couponMainVOList",
    exchangegoods: "exchangeGoodsVOList",
    group: "groupVOList"
  };
  // 如果权益品或者代金券没有返回数量，0 不显示数量，1精确显示就赋值99999+ 2模糊显示就赋值100+
  const balanceAmountMap = {
    1: 100001,
    2: 102
  };
  const goodsList = [];
  const target = fieldMap[item.pageType];
  for (let i = 0; i < item[target].length; i++) {
    const goods = {};
    goods.pickupStartTime = item[target][i].comStartReceiveDate || ""; // 领券开始时间
    goods.pickupEndTime = item[target][i].comEndReceiveDate || ""; // 领券结束时间
    goods.recieveTime = item[target][i].countdown || 0; // 领取倒计时
    goods.wordsColor = result.wordsColor || "#000000"; // 按钮文字颜色
    goods.backgroundColor = item.backgroundContent || "#ffffff";
    goods.couponName = item[target][i].couponName || "";
    goods.voucherCornerPic = item.voucherCornerPic || "";
    goods.couponCornerPic = item.couponCornerPic || "";
    goods.jumpUrl = item[target][i].jumpUrl; // 权益品配置的链接地址
    goods.exchangeGoodsName = item[target][i].exchangeGoodsName || ""; // 权益品的名称
    goods.restrictType = item[target][i].restrictType || ""; // 0:不限制 2:新老用户 999:多方认证
    goods.restrictTypeName = item[target][i].restrictTypeName || "";
    goods.exchangeGoodsCode = item[target][i].exchangeGoodsCode || "";
    goods.userAuthenticationValue =
      item[target][i].userAuthenticationValue || ""; // 身份限制字段

    // 如果是权益包，时间从effectiveEndTime取
    if (target === "groupVOList") {
      goods.pickupStartTime = item[target][i].effectiveStartTime || ""; // 权益品有效时间
      goods.pickupEndTime = item[target][i].effectiveEndTime || ""; // 权益品有效时间
    }
    // 立即领取按钮图
    if (result.receiveButtonImgUrl) {
      const receiveButtonImgUrl = JSON.parse(result.receiveButtonImgUrl);
      goods.receiveButtonImgUrl = comUtils.getImageUrl(
        receiveButtonImgUrl.file || ""
      );
    } else {
      goods.receiveButtonImgUrl = require("../../../../../static/runtime/images/magic/receiveButtonImgUrl.png");
    }

    // 去使用按钮图
    if (result.exchangeButtonImgUrl) {
      const exchangeButtonImgUrl = JSON.parse(result.exchangeButtonImgUrl);
      goods.exchangeButtonImgUrl = comUtils.getImageUrl(
        exchangeButtonImgUrl.file || ""
      );
    } else {
      goods.exchangeButtonImgUrl = require("../../../../../static/runtime/images/magic/exchangeButtonImgUrl.png");
    }

    // 不可领取按钮图
    if (result.notReceiveButtonImgUrl) {
      const notReceiveButtonImgUrl = JSON.parse(result.notReceiveButtonImgUrl);
      goods.notReceiveButtonImgUrl = comUtils.getImageUrl(
        notReceiveButtonImgUrl.file || ""
      );
    } else {
      goods.notReceiveButtonImgUrl = require("../../../../../static/runtime/images/magic/notReceiveButtonImgUrl.png");
    }

    if (
      item[target][i].activityGoodsImg ||
      item[target][i].activityVoucherImg ||
      item[target][i].exchangeGoodsGroupDetailPictureUrl
    ) {
      const mainImg = JSON.parse(
        item[target][i].activityGoodsImg ||
        item[target][i].activityVoucherImg ||
        item[target][i].exchangeGoodsGroupDetailPictureUrl
      );
      goods.mainImg = comUtils.getImageUrl(mainImg.file || "");
    }

    // 奖券剩余数量
    if (item[target][i].balanceAmount || item[target][i].balanceAmount === 0) {
      goods.balanceAmount = item[target][i].balanceAmount;
    } else {
      goods.balanceAmount = balanceAmountMap[result.showRemainingAmountWay];
    }

    // 显示模糊数量/精确数量
    goods.showRemainingAmountWay = result.showRemainingAmountWay;
    goods.useStatus = item[target][i].useStatus;
    goodsList.push(goods);
  }
  return goodsList;
}

/**
 * 专题活动，优惠券、免息券楼层数据处理
 * @param {Object} result
 * @param {Array} item
 */
export function couponDataHandler(result, item) {
  const resObj = {};
  // 判空处理
  if (!item || !result) {
    return resObj;
  }
  const { couponMainVOList, imgUrl } = item;
  //优惠券/支付宝免息券楼层
  if (couponMainVOList && couponMainVOList.length > 0) {
    // 楼层背景图
    if (imgUrl) {
      const img = JSON.parse(imgUrl) || {};
      resObj.filePath = comUtils.getImageUrl(img.file);
    }
    const list = couponMainVOList.map(row => {
      const {
        startUseDate,
        endDate,
        activityVoucherImg,
        comStartReceiveDate,
        comEndReceiveDate,
        countdown
      } = row;
      const coupon = Object.assign({}, row);
      if (startUseDate) {
        coupon.startUseDate = startUseDate.substr(0, 10).replace(/-/g, ".");
      }
      if (endDate) {
        coupon.endDate = endDate.substr(0, 10).replace(/-/g, ".");
      }
      // 优惠券、免息券展示图
      if (activityVoucherImg) {
        const mainImg = JSON.parse(activityVoucherImg);
        coupon.mainImg = comUtils.getImageUrl(mainImg.file || "");
      }
      coupon.isLoading = false;
      // 优惠券、免息券领取时间（券的层级）
      coupon.pickupStartTime = comStartReceiveDate || "";
      coupon.pickupEndTime = comEndReceiveDate || "";
      // 领取倒计时（券的层级）
      coupon.recieveTime = countdown || 0;
      return coupon;
    });
    resObj.couponMainVOList = list;
    if (item.backgroundContent) {
      try {
        // 尝试解析字符串
        const backgroundContent = JSON.parse(item.backgroundContent);
        resObj.posterPath = comUtils.getImageUrl(backgroundContent.file);
      } catch (err) {
        // to do nothing
      }
    }
    // 文字颜色配置
    if (result.wordsColor) {
      resObj.wordsColor = result.wordsColor || "#000000";
    }
    // 优惠券角标
    if (result.activityConfig && result.activityConfig.couponCornerPic) {
      const couponCornerPic = JSON.parse(result.activityConfig.couponCornerPic);
      resObj.couponCornerPic = comUtils.getImageUrl(couponCornerPic.file || "");
    }
    // 免息券角标
    if (result.activityConfig && result.activityConfig.offInterestCornerPic) {
      const offInterestCornerPic = JSON.parse(
        result.activityConfig.offInterestCornerPic
      );
      resObj.offInterestCornerPic = comUtils.getImageUrl(
        offInterestCornerPic.file || ""
      );
    }

    // 剩余展示数量文案展示条件：显示模糊数量/精确数量
    resObj.showRemainingAmountWay = result.showRemainingAmountWay;
    // 按钮配置（活动层级）

    // 立即领取按钮背景图
    if (result.receiveButtonImgUrl) {
      const receiveButtonImgUrl = JSON.parse(result.receiveButtonImgUrl);
      resObj.receiveButtonImgUrl = comUtils.getImageUrl(
        receiveButtonImgUrl.file || ""
      );
    } else {
      resObj.receiveButtonImgUrl = require("static/runtime/images/magic/receiveButtonImgUrl.png");
    }

    // 去使用按钮背景图
    if (result.exchangeButtonImgUrl) {
      const exchangeButtonImgUrl = JSON.parse(result.exchangeButtonImgUrl);
      resObj.exchangeButtonImgUrl = comUtils.getImageUrl(
        exchangeButtonImgUrl.file || ""
      );
    } else {
      resObj.exchangeButtonImgUrl = require("static/runtime/images/magic/exchangeButtonImgUrl.png");
    }

    // 不可使用按钮背景图
    if (result.notReceiveButtonImgUrl) {
      const notReceiveButtonImgUrl = JSON.parse(
        result.notReceiveButtonImgUrl || ""
      );
      resObj.notReceiveButtonImgUrl = comUtils.getImageUrl(
        notReceiveButtonImgUrl.file || ""
      );
    } else {
      resObj.notReceiveButtonImgUrl = require("static/runtime/images/magic/notReceiveButtonImgUrl.png");
    }
  }
  return resObj;
}

/**
 * 跳转活动预约列表页(微信才有)
 * @param {String} loginType 登录类型
 */
export function jumpActivityGuidePage(loginType) {
  try {
    const envMark = getEnvMark();
    const isInMP = envMark === EnvMark.wechatMp;
    const jumpUrl =
      "/subpackages/activity/pages/honorSchool/activity-reservation";
    if (loginType === BWC.LoginType.Wechat) {
      // 微信小程序内
      if (isInMP) {
        wx.miniProgram.postMessage({
          h5LoginToMiniFlag: true
        });
        wx.miniProgram.navigateTo({
          url: jumpUrl,
          fail: function (res) {
            console.error("跳转活动预约列表页fail", res);
          }
        });
      } else {
        // 微信H5，暂不支持
      }
    }
  } catch (err) {
    console.error(err);
  }
}

/**
 * 用户身份限制校验逻辑（企微、社群、入会）
 * 范围：大转盘、专题活动权益品/权益包楼层
 * @param {String} userLimitStatus 用户参与活动限制状态
 * @param {String} activityType 活动类型
 * @param {Object} activityConfig 活动配置
 * @param {object} type 从父组件/子组件调用
 * @param {object} _this （非必传）执行该方法的上下文,自定义链接跳转需要
 */
export function userLimitHandler(
  userLimitStatus,
  activityType,
  activityConfig = {},
  type = "parent",
  _this = this
) {
  switch (userLimitStatus) {
    case USER_LIMIT_STATUS.QY_WECHAT_GUIDE_TIME_LIMIT:
    case USER_LIMIT_STATUS.NOT_ADD_QY_WECHA_GUIDE_LIMIT:
      qywxGuideLimit(
        userLimitStatus,
        activityType,
        activityConfig,
        type,
        _this
      );
      break;
    case USER_LIMIT_STATUS.COMMUNITY_USER_TIME_LIMIT:
    case USER_LIMIT_STATUS.NOT_ADD_COMMUNITY_LIMIT:
      communityUserLimit(
        userLimitStatus,
        activityType,
        activityConfig,
        type,
        _this
      );
      break;
    case USER_LIMIT_STATUS.JOIN_MEMBER_TIME_LIMIT:
      joinMemberLimit(userLimitStatus, activityType, activityConfig, _this);
      break;
    default:
    // do nothing
  }
}

/**
 * -配置项：
 * 1、大转盘 抽奖对象条件
 * 2、专题活动（权益品&权益包） 用户入群加导购及入会时间控制
 * -场景：
 * 不满足企微好友控制（2: 用户企微好友时间不满足，5:需要用户加企微）
 * @param {String} userLimitStatus 用户参与活动限制状态
 * @param {String} activityType 活动类型
 * @param {Object} activityConfig 活动配置
 * @param {object} type 从父组件/子组件调用
 * @param {object} _this （非必传）执行该方法的上下文,自定义链接跳转需要
 */
export async function qywxGuideLimit(
  userLimitStatus,
  activityType,
  activityConfig = {},
  type,
  _this = this
) {
  if (userLimitStatus === USER_LIMIT_STATUS.QY_WECHAT_GUIDE_TIME_LIMIT) {
    const tips =
      activityType === ActivityType.bigTurnable
        ? "您不是新用户，无法获得抽奖机会"
        : "您不是新用户，无法领取此奖品";
    Dialog.alert({
      message: tips
    });
  } else {
    if (
      activityConfig.qyWechatJoinPathConfig ===
      QY_WECHAT_JOIN_PATH_CONFIG.NO_SETTING
    ) {
      // 引导方式：不设置
      const noSettingTips =
        activityType === ActivityType.bigTurnable
          ? "您还未添加导购企微好友，暂无抽奖机会"
          : "您还未添加导购企微好友，无法领取此奖品";
      Dialog.alert({
        message: noSettingTips
      });
    } else if (
      activityConfig.qyWechatJoinPathConfig ===
      QY_WECHAT_JOIN_PATH_CONFIG.CHANNEL_STORE_GUIDE_QR_CODE
    ) {
      // 引导方式：消费者最新门店导购企微二维码
      let locationInfo =
        JSON.parse(sessionStorage.getItem("locationInfo")) || {};
      const longitude = locationInfo.longitude || "";
      const latitude = locationInfo.latitude || "";
      if (!longitude || !latitude) {
        Toast.loading({
          message: "定位中...",
          forbidClick: true,
          duration: 0
        });
        locationInfo = await AMapGetLocation();
        console.log("获取当前位置信息==>", locationInfo);
        sessionStorage.setItem("locationInfo", JSON.stringify(locationInfo));
        Toast.clear();
      }
      getQywxGuideList(
        locationInfo,
        activityConfig.bigWheelChannelActivityCode,
        type,
        _this
      );
    } else {
      // 引导方式：自定义链接（小程序地址/H5）
      const customizeLinkTips =
        activityType === ActivityType.bigTurnable
          ? "您还未添加导购企微好友，暂无抽奖机会，去看看其他活动吧"
          : "您还未添加导购企微好友，无法领取此奖品，去看看其他活动吧";
      Dialog.confirm({
        message: customizeLinkTips,
        confirmButtonText: "去看看",
        cancelButtonText: "关闭"
      })
        .then(() => {
          activityConfig.qyWechatJoinPath
            ? jumpToNext(
              activityConfig.qyWechatJoinPath,
              JumpType.customLink,
              _this.loginType,
              _this
            )
            : "";
        })
        .catch(() => {
          // do nothing
        });
    }
  }
}

/**
 * -配置项：
 * 1、大转盘 抽奖对象条件
 * 2、专题活动（权益品&权益包） 用户入群加导购及入会时间控制
 * -场景：
 * 不满足社群用户控制（3: 用户加入社群时间不满足，6:需要用户入群）
 * @param {String} userLimitStatus 用户参与活动限制状态
 * @param {String} activityType 活动类型
 * @param {Object} activityConfig 活动配置
 * @param {object} type 从父组件/子组件调用
 * @param {object} _this （非必传）执行该方法的上下文,自定义链接跳转需要
 */
export async function communityUserLimit(
  userLimitStatus,
  activityType,
  activityConfig,
  type = "parent",
  _this = this
) {
  if (userLimitStatus === USER_LIMIT_STATUS.COMMUNITY_USER_TIME_LIMIT) {
    const tips =
      activityType === ActivityType.bigTurnable
        ? "您不是新用户，无法获得抽奖机会"
        : "您不是新用户，无法领取此奖品";
    Dialog.alert({
      message: tips
    });
  } else {
    if (
      activityConfig.communityJoinPathConfig ===
      COMMUNITY_JOIN_PATH_CONFIG.NO_SETTING
    ) {
      // 引导方式：不设置
      const noSettingTips =
        activityType === ActivityType.bigTurnable
          ? "您未加入会员群，暂无抽奖机会"
          : "您未加入会员群，无法领取此奖品";
      Dialog.alert({
        message: noSettingTips
      });
    } else if (
      activityConfig.communityJoinPathConfig ===
      COMMUNITY_JOIN_PATH_CONFIG.SET_LIVE_CODE
    ) {
      // 引导方式：设置活码地址
      let locationInfo =
        JSON.parse(sessionStorage.getItem("locationInfo")) || {};
      const longitude = locationInfo.longitude || "";
      const latitude = locationInfo.latitude || "";
      if (!longitude || !latitude) {
        Toast.loading({
          message: "定位中...",
          forbidClick: true,
          duration: 0
        });
        locationInfo = await AMapGetLocation();
        console.log("获取当前位置信息==>", locationInfo);
        sessionStorage.setItem("locationInfo", JSON.stringify(locationInfo));
        Toast.clear();
      }
      getCommunityLiveCode(
        activityConfig.communityJoinPath,
        locationInfo,
        type,
        _this
      );
    } else {
      // 引导方式：自定义链接（小程序地址/H5）
      const customizeLinkTips =
        activityType === ActivityType.bigTurnable
          ? "您未加入会员群，暂无抽奖机会，去看看其他活动吧"
          : "您未加入会员群，无法领取此奖品，去看看其他活动吧";
      Dialog.confirm({
        message: customizeLinkTips,
        confirmButtonText: "去看看",
        cancelButtonText: "关闭"
      })
        .then(() => {
          activityConfig.communityJoinPath
            ? jumpToNext(
              activityConfig.communityJoinPath,
              JumpType.customLink,
              _this.loginType,
              _this
            )
            : "";
        })
        .catch(() => {
          // do nothing
        });
    }
  }
}
/**
 * -配置项：
 * 1、大转盘 抽奖对象条件
 * 2、专题活动（权益品&权益包） 用户入群加导购及入会时间控制
 * -场景：
 * 不满足入会时间控制（4: 用户入会时间不满足）
 * @param {String} userLimitStatus 用户参与活动限制状态
 * @param {String} activityType 活动类型
 * @param {Object} activityConfig 活动配置
 * @param {object} _this （非必传）执行该方法的上下文,自定义链接跳转需要
 */
export function joinMemberLimit(
  userLimitStatus,
  activityType,
  activityConfig,
  _this = this
) {
  if (
    userLimitStatus === USER_LIMIT_STATUS.JOIN_MEMBER_TIME_LIMIT &&
    activityConfig.memberPagePathConfig === MEMBER_PAGE_PATH_CONFIG.CLOSE
  ) {
    const tips =
      activityType === ActivityType.bigTurnable
        ? "您不是新用户，无法获得抽奖机会"
        : "您不是新用户，无法领取此奖品";
    Dialog.alert({
      message: tips
    });
  } else if (
    userLimitStatus === USER_LIMIT_STATUS.JOIN_MEMBER_TIME_LIMIT &&
    activityConfig.memberPagePathConfig === MEMBER_PAGE_PATH_CONFIG.OPEN
  ) {
    const customizeLinkTips =
      activityType === ActivityType.bigTurnable
        ? "您不是新用户，无法获得抽奖机会，去看看其他活动吧"
        : "您不是新用户，无法领取此奖品，去看看其他活动吧";
    Dialog.confirm({
      message: customizeLinkTips,
      confirmButtonText: "去看看",
      cancelButtonText: "关闭"
    })
      .then(() => {
        activityConfig.memberPagePath
          ? jumpToNext(
            activityConfig.memberPagePath,
            JumpType.customLink,
            _this.loginType,
            _this
          )
          : "";
      })
      .catch(() => {
        // do nothing
      });
  }
}

/**
 * 获取社群活码的url
 * @param {String} liveCodeUrl 获取企微二维码接口地址
 * @param {object} locationInfo 用户经纬度信息
 * @param {object} type 从父组件/子组件调用
 * @param {object} _this （非必传）执行该方法的上下文
 */
async function getCommunityLiveCode(
  liveCodeUrl,
  locationInfo,
  type = "parent",
  _this = this
) {
  let lng = "116.403883";
  let lat = "39.915156";
  if (locationInfo.longitude && locationInfo.latitude) {
    lng = locationInfo.longitude;
    lat = locationInfo.latitude;
  }
  // 获取门店编码，channelCode
  const channelCode = await getStoreCode(liveCodeUrl, lng, lat, _this);
  // 获取社群码的二维码URL
  const url = `${liveCodeUrl}/${lng}/${lat}/2`;
  const userToken = sessionStorage.getItem("userToken");
  const accessToken = sessionStorage.getItem("accessToken");
  const headers = {
    system_name: "hd",
    traceId: comUtils.getuid(),
    "x-from": "h5-hd",
    "x-user-token": userToken || "",
    "x-access-token": accessToken || ""
  };
  const cfgObj = {
    method: "GET",
    url: url,
    withCredentials: true,
    async: false,
    headers: headers
  };
  const axios = require("axios");
  axios(cfgObj)
    .then(res => {
      if (res && res.data) {
        const r = res.data;
        if (r.code === 200) {
          if (r.result && type === "children" && _this.$parent) {
            _this.$parent.$refs.communityUserLimit &&
              _this.$parent.$refs.communityUserLimit.openModal(
                r.result,
                channelCode
              );
          } else if (r.result && type === "parent") {
            _this.$refs.communityUserLimit &&
              _this.$refs.communityUserLimit.openModal(r.result, channelCode);
          } else {
            // 未获取到活码，只弹窗提示无机会
            Dialog.alert({
              message:
                _this.activityType === ActivityType.bigTurnable
                  ? "您未加入会员群，暂无抽奖机会"
                  : "您未加入会员群，无法领取此奖品"
            });
          }
        } else if (r.code === 505) {
          const isWeChat =
            _this.miniprogramFlag && _this.loginType === BWC.LoginType.Wechat;
          let content = "";
          if (isWeChat) {
            content =
              "获取地理位置失败，请在手机设置里打开微信位置，授权允许访问才能继续使用本次服务";
          } else {
            content =
              "获取地理位置失败，请在手机设置里打开浏览器位置，授权允许访问才能继续使用本次服务";
          }
          Dialog.alert({
            title: "提示",
            message: content
          });
        } else {
          Dialog.alert({
            title: "提示",
            message:
              (r.message && r.message.length) || "活动过于火爆，请稍后再试"
          });
        }
      } else {
        Dialog.alert({
          title: "提示",
          message: "活动过于火爆，请稍后再试"
        });
      }
    })
    .catch(err => {
      console.log("获取社群活码地址异常====>", err);
      Dialog.alert({
        title: "提示",
        message: "活动过于火爆，请稍后再试"
      });
    });
}

/**
 * 获取社群活码的所在的门店编码
 * @param {*} link 后端接口返回的，字段communityJoinPath
 * @param {*} lng 经度
 * @param {*} lat 纬度
 * @param {object} _this （非必传）执行该方法的上下文
 */
function getStoreCode(link, lng, lat, _this = this) {
  // 活动id
  const id = link.substring(link.lastIndexOf("/") + 1);
  return new Promise(resolve => {
    _this.$api.get({
      noLoading: true,
      sc: "mobileMarketing",
      url: `activityclubgroupmain/getChannelCode/${id}/${lng}/${lat}/2`,
      success: r => {
        if (r.code === 200 && r.result && r.result.channelCode) {
          const channelCode = r.result.channelCode;
          resolve(channelCode);
        } else {
          resolve("");
        }
      },
      failure: () => {
        resolve("");
      }
    });
  });
}

/**
 * 获取消费者最近门店的导购信息
 * @param {object} locationInfo 用户经纬度信息
 * @param {String} navigationActivityCode 大转盘-其他设置-活动门店设置-门店导航活动编码
 * @param {object} type 从父组件/子组件调用
 * @param {object} _this （非必传）执行该方法的上下文
 */
function getQywxGuideList(
  locationInfo,
  navigationActivityCode,
  type = "parent",
  _this = this
) {
  let lng = "116.403883";
  let lat = "39.915156";
  if (locationInfo.longitude && locationInfo.latitude) {
    lng = locationInfo.longitude;
    lat = locationInfo.latitude;
  }
  const params = {
    latitude: lat,
    longitude: lng,
    coordinateType: CoordinateType.GCJ02,
    navigationActivityCode: navigationActivityCode || ""
  };
  _this.$api.post({
    sc: "mobileMarketing",
    url: "weChatWorkUserInfoManage/queryGuideUserListByCoordinate",
    params: params,
    success: r => {
      if (r.code === 200 && r.result && r.result.length) {
        if (type === "children" && _this.$parent) {
          _this.$parent.$refs.qywxGuideLimit &&
            _this.$parent.$refs.qywxGuideLimit.openModal(r.result);
        } else if (type === "parent") {
          _this.$refs.qywxGuideLimit &&
            _this.$refs.qywxGuideLimit.openModal(r.result);
        } else {
          Dialog.alert({
            message:
              _this.activityType === ActivityType.bigTurnable
                ? "您还未添加导购企微好友，暂无抽奖机会"
                : "您还未添加导购企微好友，无法领取此奖品"
          });
        }
      } else {
        Dialog.alert({
          message:
            _this.activityType === ActivityType.bigTurnable
              ? "您还未添加导购企微好友，暂无抽奖机会"
              : "您还未添加导购企微好友，无法领取此奖品"
        });
      }
    },
    failure: err => {
      console.log("获取消费者最近门店的导购信息失败", err);
      Dialog.alert({
        message:
          _this.activityType === ActivityType.bigTurnable
            ? "您还未添加导购企微好友，暂无抽奖机会"
            : "您还未添加导购企微好友，无法领取此奖品"
      });
    }
  });
}

/**
 * 获取经纬度信息
 */
export async function getPosition() {
  let positionInfo = {};
  const locationInfo = JSON.parse(sessionStorage.getItem("locationInfo")) || {};
  const longitude = locationInfo.longitude || "";
  const latitude = locationInfo.latitude || "";
  if (longitude && latitude) {
    positionInfo = locationInfo;
  } else {
    try {
      Toast.loading({
        message: "定位中...",
        forbidClick: true,
        duration: 0 // 默认值为2秒，设置为0，表示不会消失，需手动清除
      });
      positionInfo = await AMapGetLocation();
      sessionStorage.setItem("locationInfo", JSON.stringify(positionInfo));
      console.log("当前的位置信息：positionInfo", positionInfo);
      Toast.clear();
    } catch (err) {
      console.error(err);
      Toast.clear();
    }
  }
  return positionInfo;
}
/**
 * 邀请有礼按钮拦截校验
 * 点击按钮，若活动状态更新则拦截跳转，提示用户刷新页面
 * 按钮包含：活动详情页-去邀请、去添加，活动助力页-我来助力按钮
 * @param {String} shareId  活动助力页分享id
 * @param {String} taskCode 任务编码
 * @param {String} activityCode 活动编码
 * @param {object} _this （非必传）执行该方法的上下文
 * @returns
 */
export function checkActivityStatus(taskCode, activityCode, shareId, _this) {
  return new Promise(resolve => {
    const params = {
      shareId,
      taskCode,
      activityCode
    };
    _this &&
      _this.$api.post({
        sc: "mobileMarketingH5",
        url: "activityTask/check",
        params,
        success: res => {
          if (res && res.code === 200) {
            resolve(true);
          } else {
            const tips = res.message ? res.message : "活动已更新，请下拉刷新页面后继续"
            Toast(tips);
            resolve(false);
          }
        },
        failure: err => {
          Toast("出错了，请稍后再试");
          resolve(false);
        }
      });
  });
}



// WEBPACK FOOTER //
// ./src/page/vibrantRubikCube/runtime/common-methods/utils.js